import React from "react";

import BillingCountrySelectionComponent from "./BillingCountrySelectionComponent";

export default function BillingStateSelectionContainer(props) {
  return <BillingCountrySelectionComponent {...props} />;
}
